
import anaelBerlisnky from '../src/images/digicards/beauty/anaelBerlisnky.png';
import beUnique from '../src/images/digicards/beauty/beUnique.png';
import edenShviro from '../src/images/digicards/beauty/edenShviro.png';
import evlinTurjeman from '../src/images/digicards/beauty/evlinTurjeman.png';
import ilanitKopel from '../src/images/digicards/beauty/ilanitKopel.png';
import inbarDrori from '../src/images/digicards/beauty/inbarDrori.png';
import liaBar from '../src/images/digicards/beauty/liaBar.png';
import maliAtias from '../src/images/digicards/beauty/maliAtias.png';
import miraPeretz from '../src/images/digicards/beauty/miraPeretz.png';
import moranAzarzar from '../src/images/digicards/beauty/moranAzarzar.png';
import nataliYomTov from '../src/images/digicards/beauty/nataliYomTov.png';
import oksanaFreidin from '../src/images/digicards/beauty/oksanaFreidin.png';
import revitalEdri from '../src/images/digicards/beauty/revitalEdri.png';
import roniBiton from '../src/images/digicards/beauty/roniBiton.png';
import roniLevi from '../src/images/digicards/beauty/roniLevi.png';
import sigalitVanunu from '../src/images/digicards/beauty/sigalitVanunu.png';
import sivanGafni from '../src/images/digicards/beauty/sivanGafni.png';
import svetlanaCavalli from '../src/images/digicards/beauty/svetlanaCavalli.png';
import taliaBenAtar from '../src/images/digicards/beauty/taliaBenAtar.png';
import tanya from '../src/images/digicards/beauty/tanya.png';




// Design images
import ilanitKopelPhotographer from '../src/images/digicards/design/ilanitKopelPhotographer.png';
import kerenPaz from '../src/images/digicards/design/kerenPaz.png';
import naamaTennenbaum from '../src/images/digicards/design/naamaTennenbaum.png';
import shlihaNemana from '../src/images/digicards/design/shlihaNemana.png';

// Food image
import sovaSmahot from '../src/images/digicards/food/sovaSmahot.png';

// Production images
import caduri from '../src/images/digicards/production/caduri.png';
import dgTechnology from '../src/images/digicards/production/dgTechnology.png';

// Then construct the images data array with URLs (replace placeholders with actual URLs)
const imagesData = [

    { src: inbarDrori, filter: "beauty", url: "https://inbaramon.netlify.app/" },
    { src: roniBiton, filter: "beauty", url: "https://ronibiton.netlify.app/" },
    { src: beUnique, filter: "beauty", url: "https://beuniquehairstyling.netlify.app/" },
    { src: edenShviro, filter: "beauty", url: "https://edenshviro.netlify.app/" },
    { src: evlinTurjeman, filter: "beauty", url: "https://evlinturjeman.netlify.app/" },
    { src: roniLevi, filter: "beauty", url: "https://ronilevi.netlify.app/" },
    { src: anaelBerlisnky, filter: "beauty", url: "https://anaelberlinsky.netlify.app/" },
    { src: liaBar, filter: "beauty", url: "https://liabar.netlify.app/" },
    { src: maliAtias, filter: "beauty", url: "https://maliatias.netlify.app/" },
    { src: miraPeretz, filter: "beauty", url: "https://miraperetz.netlify.app/" },
    { src: moranAzarzar, filter: "beauty", url: "https://moranhairdesign.netlify.app/" },
    { src: nataliYomTov, filter: "beauty", url: "https://nytclinic.netlify.app/" },
    { src: oksanaFreidin, filter: "beauty", url: "https://oksicosmetics.netlify.app/" },
    { src: revitalEdri, filter: "beauty", url: "https://revinails.netlify.app/" },
    { src: ilanitKopel, filter: "beauty", url: "https://ilanitkopel.netlify.app/" },
    { src: sigalitVanunu, filter: "beauty", url: "https://sigalitvanunu.netlify.app/" },
    { src: sivanGafni, filter: "beauty", url: "https://sivangafni.netlify.app/" },
    { src: svetlanaCavalli, filter: "beauty", url: "https://svetlanacavalli.netlify.app/" },
    { src: taliaBenAtar, filter: "beauty", url: "https://taliacosmetics.netlify.app/" },
    { src: tanya, filter: "beauty", url: "https://tanyacosmetics.netlify.app/" },

    { src: ilanitKopelPhotographer, filter: "design", url: "https://ilanitkopelphotographer.netlify.app/" },
    { src: kerenPaz, filter: "design", url: "https://pazpilates.netlify.app/" },
    { src: naamaTennenbaum, filter: "design", url: "https://naamaten.com/" },
    { src: shlihaNemana, filter: "design", url: "https://shlihanemana.netlify.app/" },

    { src: sovaSmahot, filter: "food", url: "https://sovehasmahot.netlify.app/" },

    { src: caduri, filter: "production", url: "https://caduri.netlify.app/" },
    { src: dgTechnology, filter: "production", url: "https://dgtechnology.netlify.app/" }
];

export default imagesData;
